import log from 'salvo-lite/log'

class CookieBanner {
    constructor (theme, elem) {
        this.theme = theme
        this._elem = elem
        this._closeElem = this._elem.querySelector('[data-close]')
        this._options = Object.assign({
            timeout: 1000 * 60 * 60 * 24 * 30,
            dontInit: false,
            localStorageKey: 'ESC_COOKIE_BANNER'
        }, JSON.parse(this._elem.dataset.options || '{}'))
        if (!this._options.dontInit) {
            this.init()
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    init () {
        log.debug(this.constructor.name, 'Initiating')

        if (localStorage.getItem(this._options.localStorageKey)) {
            let lastShown = localStorage.getItem(this._options.localStorageKey)
            let timeNow = new Date().getTime()
            if (timeNow - lastShown >= this._options.timeout) {
                localStorage.removeItem(this._options.localStorageKey)
            }
        }

        if (!localStorage.getItem(this._options.localStorageKey)) {
            this._elem.classList.add('shown')
            document.body.classList.add('cookie-shown')
        }

        this._closeElem.addEventListener('click', (e) => {
            e.preventDefault()
            localStorage.setItem(this._options.localStorageKey, new Date().getTime())
            this._elem.classList.remove('shown')
            document.body.classList.remove('cookie-shown')
        })

        log.debug(this.constructor.name, 'Initiated')
    }

    onInit () {
    }
}

export default CookieBanner



// WEBPACK FOOTER //
// ./src/scripts/components/CookieBanner.js